import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { AnalyticsEvent } from 'services/analytics-events';
import { getDetailView, getPageTab, resolvePage } from 'services/analytics-helpers';
import { setCurrentPageName, trackEvent } from 'services/analytics';

export const usePageViewTracking = (isLoggedIn: boolean, isReady: boolean) => {
  const { pathname, search } = useLocation();
  const lastSentRef = useRef<string | null>(null);

  useEffect(() => {
    const { pageName, pagePath } = resolvePage(pathname, isLoggedIn);
    setCurrentPageName(pageName);

    if (!isReady) return;

    const properties = {
      page_name: pageName,
      page_path: pagePath,
      page_tab: getPageTab(search),
      detail_view: getDetailView(search),
    };

    // Filter and pagination changes also update the query string; they are not new page views.
    const key = JSON.stringify(properties);
    if (key === lastSentRef.current) return;
    lastSentRef.current = key;

    trackEvent(AnalyticsEvent.PageViewed, properties);
  }, [pathname, search, isLoggedIn, isReady]);
};
